export function validateMarketOrder(data) {
  const { quantityBasisValue } = data;
  if (!quantityBasisValue || quantityBasisValue <= 0)
    return [
      false,
      'Please provide a positive quantity basis value larger than 0.',
    ];
  return [true, ''];
}
